module.exports = __webpack_public_path__ + "static/media/img--1380x623.67d85562.67d85562.jpg";